import { Serializable } from "../utilities/Serializable";

export class DateTime extends Serializable {
    public date: Date;
    public time: Date;

    constructor() {
        super();
    }

    getDate() {
        if (this.date)
            return this.time ? new Date(this.date.toDateString() + ' ' + this.time.toLocaleTimeString()).toISOString()
                : new Date(this.date.toDateString() + ' 00:00:00').toISOString()
    }

    setDate(date: string) {
        let _datetime = new Date(date);
        this.date = _datetime;
        this.time = _datetime;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/DateTime.ts